// Contract upgrade flags - isolated to prevent circular dependencies

// Set to true during Ethereum contract upgrades
// This will show an upgrade banner and disable withdrawals
export const IS_CONTRACT_UPGRADE_IN_PROGRESS = false;

// Set to true while a recovery effort is in progress.
// When combined with the on-chain `paused()` state, this switches the
// pause notice copy to reference the recovery plan and exposes the link.
export const RECOVERY_EFFORT_ONGOING = false;

// Public link explaining the recovery plan. Shown only when
// RECOVERY_EFFORT_ONGOING is true and the deposit pool is paused.
// TODO: replace with the final recovery-plan URL.
export const RECOVERY_PLAN_URL =
  "https://x.com/aave/status/2048958367658332413";
